(function () {
  'use strict';

  trainerPrivilege.$inject = ['mtypes', 'Auth', '$window'];
  angular
    .module('trainerWebApp.services')
    .factory('trainerPrivilege', trainerPrivilege);

  function trainerPrivilege(mtypes, Auth, $window) {
    var service = {
      roles: roles
    };

    return service;

    ///////////////

    //roles needs to be refreshed
    function roles() {
      var hasLiveTrainingFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.liveTraining);
      var hasNewSeriesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newSeries);
      return {
        canInviteUsers: Auth.hasUserPrivilege(mtypes.userPrivilege.canInviteUsers),
        canDropTrainees: Auth.hasUserPrivilege(mtypes.userPrivilege.canDropTrainees),
        canExtendTraineeDeadlines: Auth.hasUserPrivilege(mtypes.userPrivilege.canExtendTraineeDeadlines),
        canResetTrainees: Auth.hasUserPrivilege(mtypes.userPrivilege.canResetTrainees),
        canRemindTrainees: Auth.hasUserPrivilege(mtypes.userPrivilege.canRemindTrainees),
        canEditCourses: Auth.hasUserPrivilege(mtypes.userPrivilege.canEditCourses),
        canEditCustomFields: Auth.hasUserPrivilege(mtypes.userPrivilege.canEditCustomFields),
        canViewCatalogs: Auth.hasUserPrivilege(mtypes.userPrivilege.canViewCatalogs),
        canEditGroups: Auth.hasUserPrivilege(mtypes.userPrivilege.canEditGroups),
        canEditGroupMembership: Auth.hasUserPrivilege(mtypes.userPrivilege.canEditGroupMembership),
        canViewDraftCourses: Auth.hasUserPrivilege(mtypes.userPrivilege.canViewDraftCourses),
        canPreviewCourse: Auth.hasUserPrivilege(mtypes.userPrivilege.canPreviewCourse),
        canArchiveUsers: Auth.hasUserPrivilege(mtypes.userPrivilege.canArchiveUsers),
        canEditUserInfo: Auth.hasUserPrivilege(mtypes.userPrivilege.canEditUserInfo),
        canUpdateTraineesInSeries: Auth.hasUserPrivilege(mtypes.userPrivilege.canUpdateTraineesInSeries) && hasNewSeriesFeature,
        canMarkTraineeCompleted: Auth.hasUserPrivilege(mtypes.userPrivilege.canMarkTraineeCompleted) && hasLiveTrainingFeature,
        canSetTraineeScore: Auth.hasUserPrivilege(mtypes.userPrivilege.canSetTraineeScore) && hasLiveTrainingFeature
      }
    }
  }

})();
